"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyleProps = exports.measureElement = exports.getElementHeight = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _StringUtils = require("./StringUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Given a react element return the height of the element.
 *
 * @param {React.PropType.element} element - react element (must be rendered)
 * @returns {number} - height if found else 0
 */
var getElementHeight = function getElementHeight(element) {
  if (element && element.getBoundingClientRect) {
    return element.getBoundingClientRect().height;
  }

  return 0;
};
/**
 * Measures height and width of an element. If no element is found it will return a value
 *   of {0} for both.
 * Note: Useful for measuring proxy components (Class Components) and their DOM node.
 * More explanation: https://reactjs.org/docs/refs-and-the-dom.html
 *
 * @param {React.PropType.element} element - react element (must be rendered)
 * @returns {object} - of width {number} and height {number}.
 */


exports.getElementHeight = getElementHeight;

var measureElement = function measureElement(element) {
  // eslint does not want to use findDOMNode. See note above.
  // eslint-disable-next-line
  var DOMNode = element && _reactDom.default.findDOMNode(element);

  var width = DOMNode ? DOMNode.offsetWidth : 0;
  var height = DOMNode ? DOMNode.offsetHeight : 0;
  return {
    width: width,
    height: height
  };
};
/**
 * Converts a list of style keys to data-attr props for styling usage
 *
 * @param {array} styleKeys - array of style keys to convert to data-attr props
 * @param {object} props - full list of React element props
 * @returns {object} - converted style data-attr props to be used on DOM
 */


exports.measureElement = measureElement;

var getStyleProps = function getStyleProps(styleKeys, props) {
  // Merge and transform all styleKeys to kebab case data attr props.
  var styleProps = {};
  styleKeys.forEach(function (propKey) {
    var value = props[propKey];

    if (value) {
      styleProps["data-".concat((0, _StringUtils.camelToKebab)(propKey))] = value;
    }
  });
  return styleProps;
};

exports.getStyleProps = getStyleProps;